import axios from 'axios';
import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmationModal from '../shared/ConfirmationModal';
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";

function EditDepartment() {
    const { id } = useParams();
    const [data, setdata] = useState(null);
    const [edit, setEdit] = useState(null);
    const [showModal, setShowModal] = useState(false); // Modal visibility state
    const [modalMessage, setModalMessage] = useState(""); // Modal message state
    const [operationType, setOperationType] = useState(""); // Operation type (Confirm/Close)
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [showFailureModal, setShowFailureModal] = useState(false);
    const [failureMessage, setFailureMessage] = useState("");
    const headers = {
        "x-access-token": localStorage.getItem("jwttoken") || "",
      };
    const navigate = useNavigate();

    const getDepartment = async () => {
        try {
            const url = process.env.REACT_APP_API_URL + `department/getdepartment/${id}`;
            const response = await axios.get(url,{headers});
            setdata(response.data[0]);
            setEdit(response.data[0]); 
        } catch (error) {
            // alert(error.message);
            // console.log(error);
        }
    };
    useEffect(() => {
        getDepartment();
    }, [])

    const handleUpdateConfirmation = () => {
        // Show confirmation modal before proceeding with the update
        setModalMessage("Are you sure you want to update the Department?");
        setOperationType("Confirm");
        setShowModal(true);
    };

    async function handleUpdate() {
        try {
            const url = process.env.REACT_APP_API_URL + `department/updatedepartment/${id}`;
            const response = await axios.put(url, { department_name: edit.department_name }, {headers});
            setSuccessMessage("Department updated successfully.");
            setShowSuccessModal(true);
        } catch (error) {
            setFailureMessage(`Failed to update department. ${error.message || ''}`);
            setShowFailureModal(true); 
        }
        finally{
            setTimeout(() => navigate('/department'), 3000);
        }
    }
    return (
        <>
            {!data && <div>Nothing to update</div>}
            {data && (
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card mt-5">
                            <div className="card-header bg-info text-white">
                                <h4 className="mb-0">Update Department Details</h4>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="departmentName" className="form-label">Department Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="department_name"
                                        placeholder="Enter department name"
                                        required
                                        value={edit.department_name}
                                        onChange={(e) => setEdit({ ...edit, department_name: e.target.value })}
                                    />
                                </div>
                                <div className='d-flex justify-content-between'>
                                    <button
                                        className="btn btn-info"
                                        disabled={edit.department_name === data.department_name}
                                        onClick={handleUpdateConfirmation}
                                    >
                                        Update Department
                                    </button>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => navigate('/department')}
                                    >
                                        Go Back
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
                <ConfirmationModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    modalMessage={modalMessage}
                    operationType={operationType}
                    confirmation={handleUpdate}
                />
                <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="OK" timeoutDuration={3000} />
                <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage} operationType="OK" timeoutDuration={5000} />

        </>
    )
}

export default EditDepartment